// Import React Icons for better camping/outdoor icons
import {
  GiSleepingBag, GiCampingTent, GiBackpack, GiCookingPot,
  GiLifeJacket, GiDuffelBag, GiPillow, GiBallPyramid, GiBarbecue, GiCooler
} from 'react-icons/gi';
import { FaKitchenSet } from "react-icons/fa6";
import {
  FaChair, FaFire, FaUtensils, FaWater, FaUmbrellaBeach,
  FaShower, FaBed, FaVolleyballBall, FaGamepad, FaMusic,
  FaShoppingCart, FaMountain, FaTools, FaFirstAid,
  FaWifi, FaPhoneAlt, FaBolt
} from 'react-icons/fa';
import {
  MdKitchen, MdOutdoorGrill, MdSpeaker, MdLocalGroceryStore,
  MdSecurity, MdCleaningServices, MdBathtub, MdTableRestaurant,
  MdSportsBaseball, MdSurfing, MdPool,
  MdBeachAccess, MdLocationCity, MdBuild, MdMenuBook
} from 'react-icons/md';
import {
  TbFlame, TbSwimming, TbWalk, TbFish, TbUmbrella
} from 'react-icons/tb';
import { BiBlanket } from "react-icons/bi";
import { PiTowelFill, PiWindBold } from 'react-icons/pi';
import { LiaUmbrellaBeachSolid } from 'react-icons/lia';
import { LuToyBrick } from 'react-icons/lu';
import { GrYoga } from 'react-icons/gr';

// Icon mapping for add-ons based on icon_name from database
export const getAddonIcon = (iconName) => {
  const iconMap = {
    // Bedding & Comfort - Using available icons
    'bed': <FaBed className="addon-icon-svg" />,
    'pillow': <GiPillow className="addon-icon-svg" />,
    'bedding': <FaBed className="addon-icon-svg" />,
    'blanket': <BiBlanket className="addon-icon-svg" />,

    // Kitchen & Dining - Mix of icons for variety
    'utensils': <FaUtensils className="addon-icon-svg" />,
    'kitchen': <MdKitchen className="addon-icon-svg" />,
    'cookinghob': <TbFlame className="addon-icon-svg" />,
    'kitchenset': <FaKitchenSet className="addon-icon-svg" />,
    'cookware': <GiCookingPot className="addon-icon-svg" />,
    'plate': <FaUtensils className="addon-icon-svg" />,
    'cup': <FaUtensils className="addon-icon-svg" />,
    'cooler': <GiCooler className="addon-icon-svg" />,

    // Bathroom & Hygiene - Meaningful icons
    'bathroom': <FaShower className="addon-icon-svg" />,
    'shower': <FaShower className="addon-icon-svg" />,
    'towel': <PiTowelFill className="addon-icon-svg" />,
    'beachtowel': <LiaUmbrellaBeachSolid className="addon-icon-svg" />,
    'toiletries': <MdBathtub className="addon-icon-svg" />,

    // Sports & Water Activities - Authentic sports icons
    'sports': <MdSportsBaseball className="addon-icon-svg" />,
    'soccer': <FaVolleyballBall className="addon-icon-svg" />,
    'kayak': <MdSurfing className="addon-icon-svg" />,
    'paddle': <MdSurfing className="addon-icon-svg" />,
    'surf': <MdSurfing className="addon-icon-svg" />,
    'sup': <MdPool className="addon-icon-svg" />,
    'surfboard': <MdSurfing className="addon-icon-svg" />,
    'kitesurf': <MdSurfing className="addon-icon-svg" />,
    'fishing': <TbFish className="addon-icon-svg" />,
    'racket': <MdSportsBaseball className="addon-icon-svg" />,
    'beach': <MdBeachAccess className="addon-icon-svg" />,
    'beachumbrella': <FaUmbrellaBeach className="addon-icon-svg" />,
    'windstop': <PiWindBold className="addon-icon-svg" />,
    'water': <FaWater className="addon-icon-svg" />,
    'wetsuit': <TbSwimming className="addon-icon-svg" />,
    'snorkel': <TbSwimming className="addon-icon-svg" />,
    'lifejacket': <GiLifeJacket className="addon-icon-svg" />,
    'yoga': <GrYoga className="addon-icon-svg" />,
    'walkingsticks': <TbWalk className="addon-icon-svg" />,
    'wetbags': <GiDuffelBag className="addon-icon-svg" />,
    'hiking': <FaMountain className="addon-icon-svg" />,

    // Outdoor & Camping - Perfect camping icons
    'chair': <FaChair className="addon-icon-svg" />,
    'campingchair': <FaChair className="addon-icon-svg" />,
    'table': <MdTableRestaurant className="addon-icon-svg" />,
    'campingtable': <MdTableRestaurant className="addon-icon-svg" />,
    'camping': <GiCampingTent className="addon-icon-svg" />,
    'outdoor': <MdOutdoorGrill className="addon-icon-svg" />,
    'grill': <GiBarbecue className="addon-icon-svg" />,
    'tent': <GiCampingTent className="addon-icon-svg" />,
    'sleepingbag': <GiSleepingBag className="addon-icon-svg" />,
    'inflatables': <FaWater className="addon-icon-svg" />,
    'backpack': <GiBackpack className="addon-icon-svg" />,
    'fire': <FaFire className="addon-icon-svg" />,

    // Entertainment - Fun and recognizable
    'music': <FaMusic className="addon-icon-svg" />,
    'speaker': <MdSpeaker className="addon-icon-svg" />,
    'games': <FaGamepad className="addon-icon-svg" />,
    'toys': <LuToyBrick className="addon-icon-svg" />,
    'petanque': <GiBallPyramid className="addon-icon-svg" />,
    'book': <MdMenuBook className="addon-icon-svg" />,
    'cards': <FaGamepad className="addon-icon-svg" />,
    'entertainment': <FaGamepad className="addon-icon-svg" />,

    // Food & Shopping
    'food': <FaShoppingCart className="addon-icon-svg" />,
    'shopping': <MdLocalGroceryStore className="addon-icon-svg" />,
    'grocery': <MdLocalGroceryStore className="addon-icon-svg" />,
    'supermarket': <MdLocalGroceryStore className="addon-icon-svg" />,
    'snacks': <FaShoppingCart className="addon-icon-svg" />,

    // Technology
    'tech': <FaPhoneAlt className="addon-icon-svg" />,
    'phone': <FaPhoneAlt className="addon-icon-svg" />,
    'charger': <FaBolt className="addon-icon-svg" />,
    'power': <FaBolt className="addon-icon-svg" />,
    'cable': <FaBolt className="addon-icon-svg" />,
    'wifi': <FaWifi className="addon-icon-svg" />,

    // Safety & Tools
    'safety': <MdSecurity className="addon-icon-svg" />,
    'first-aid': <FaFirstAid className="addon-icon-svg" />,
    'tool': <FaTools className="addon-icon-svg" />,
    'repair': <FaTools className="addon-icon-svg" />,
    'emergency': <MdSecurity className="addon-icon-svg" />,

    // Cleaning
    'clean': <MdCleaningServices className="addon-icon-svg" />,
    'soap': <MdCleaningServices className="addon-icon-svg" />,
    'sanitizer': <MdCleaningServices className="addon-icon-svg" />,

    // Default fallback
    'default': <MdBuild className="addon-icon-svg" />
  };

  return iconMap[iconName?.toLowerCase()] || iconMap['default'];
};

// Get category-based fallback icon if specific icon not found
export const getCategoryIcon = (categoryName) => {
  const categoryMap = {
    'bedroom': <FaBed className="addon-icon-svg" />,
    'bathroom': <FaShower className="addon-icon-svg" />,
    'sports': <MdSportsBaseball className="addon-icon-svg" />,
    'entertainment': <FaGamepad className="addon-icon-svg" />,
    'comfort': <TbUmbrella className="addon-icon-svg" />,
    'kitchen': <MdKitchen className="addon-icon-svg" />,
    'extras': <GiCampingTent className="addon-icon-svg" />,
    'outdoor': <MdLocationCity className="addon-icon-svg" />,
    'safety': <MdSecurity className="addon-icon-svg" />,
    'technology': <FaPhoneAlt className="addon-icon-svg" />
  };

  return categoryMap[categoryName?.toLowerCase()] || <MdBuild className="addon-icon-svg" />;
};